module.exports = __webpack_public_path__ + "static/media/IMG_1617.910c88e5.JPG";